import { create } from "zustand";
import { persist } from "zustand/middleware";

// M2 (feature/3) — 新增 'trainer' 角色支援
export type AppRole = "owner" | "manager" | "trainer";

interface RoleState {
  currentRole: AppRole | null;
  currentUserId: string | null;
  loginAs: (role: AppRole, userId?: string) => void;
  logout: () => void;
}

export const useRoleStore = create<RoleState>()(
  persist(
    (set) => ({
      currentRole: null,
      currentUserId: null,
      loginAs: (role, userId) => set({ currentRole: role, currentUserId: userId ?? null }),
      logout: () => set({ currentRole: null, currentUserId: null }),
    }),
    {
      name: "trainer-admin-role",
    },
  ),
);
